import React from "react";
import { Link } from "react-router-dom";
import "./style.scss";

export default function NotFoundPage() {
  return (
    <React.Fragment>
      <div className={"section section-not-found"}>
        <div className={"section-heading"}>
          {/* <h4 className={"section-title"}>NOT FOUND</h4> */}
        </div>
        <div className={"section-body"}>
          <h4>NOT FOUND</h4>
          <p>Sorry, we couldn't find that page</p>

          <p>
            You can go back to our 
            <Link to="/home"> Homepage.</Link>
          </p>
          {/* <img src="/assets/images/bg-welcome.png" alt="" /> */}
        </div>
      </div>
    </React.Fragment>
  );
}
